<template>
  <div class="gc-data-grid-report">
    <!-- <GcDataGrid
      :grouping="true"
      :export="true"
      :summary="true"
      :exportFileName="exportFileName"
      :dataSourceConfig="dataSourceConfig"
      :columns="columns"
      :gridToolbar="gridToolbar"
      :padColumn="true"
      :id="'grid-report-grid'"
      :rowClick="rowClickCallBack"
      :auto-expand-all="false"
      :gridOptions="gridOptions"
    /> -->
    <GcDataGrid
      :grouping="true"
      :export="true"
      :summary="true"
      :exportFileName="exportFileName"
      :dataSourceConfig="dataSourceConfig"
      :columns="columns"
      :gridToolbar="getGridToolbar"
      :padColumn="true"
      :id="'grid-report-grid'"
      :rowClick="rowClickCallBack"
      :auto-expand-all="false"
      :gridOptions="gridOptions"
      :title="title"
      :persistenceKey="persistenceKey"
      :heightPadding="heightPadding"
      :save-grid-layout="true"
      :key="gridKey"
      :pdfEngineV2="pdfEngineV2"
      ref="dataGridReport"
      :rowAlternationEnabled="false"
    />

    <gcPopupSaveLayout
      v-if="persistenceKey !== undefined && getVisibleGridSavePopup"
      :visible.sync="getVisibleGridSavePopup"
      :persistenceKey="persistenceKey"
      :original-columns="deepCloneColumns"
    />
  </div>
</template>

<script>
// import GcDataGrid from "./gc-data-grid";

import { DataGridState } from "../_models/data-grid-state";
import { CommonStorage } from "../_services/storage";
import GcPopupSaveLayout from "../popups/data-grid/gc-popup-save-layout.vue";
import { mapGetters } from "vuex";

import DataGridHelpers from "@/_helpers/data-grid/helpers";
const { syncDateFilters } = DataGridHelpers;

export default {
  props: {
    persistenceKey: {
      type: String,
      default: undefined,
    },
    exportFileName: {
      type: String,
    },
    dataSourceConfig: {
      type: Object,
    },
    columns: {
      type: Array,
    },
    rowClickCallBack: {
      type: Function,
      default: () => {},
    },
    gridOptions: {
      type: Object,
      default: () => {},
    },
    title: {
      type: String,
      default: "grid-report",
    },
    heightPadding: {
      type: Number,
      default: 0,
    },
    gridToolbar: {
      type: Object,
      default: () => {},
    },
    originalColumns: {
      type: Array,
      default: () => [],
    },
    // Pass-through opt-in for the experimental jspdf-autotable PDF engine (exporter-v2) —
    // see gc-data-grid.vue's pdfEngineV2 prop and docs/pdf-export/session-summary.md Topic 5.
    pdfEngineV2: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    //
    return {
      gridKey: new Date().getTime(),
    };
  },
  components: {
    GcPopupSaveLayout,
  },
  computed: {
    deepCloneColumns() {
      return JSON.parse(JSON.stringify(this.originalColumns));
    },
    ...mapGetters({
      getTriggerViewDefinitionChange:
        "gridViewDefinition/getTriggerViewDefinitionChange",
    }),

    ...mapGetters({
      getSelectedDefinitionByKey:
        "gridViewDefinition/getSelectedDefinitionByKey",
    }),
    ...mapGetters({ visibleGridSavePopup: "ui/getVisibleGridSavePopup" }),
    getGridToolbar() {
      if (this.gridToolbar) return this.gridToolbar;
      else
        return {
          search: true,
          columnChooser: true,
          export: true,
          openFilter: true,
        };
    },
    getVisibleGridSavePopup: {
      get() {
        return this.visibleGridSavePopup;
      },
      set(val) {
        this.$store.dispatch("ui/setVisibleGridSavePopup", val);
      },
    },
  },
  async created() {
    if (
      Object.keys(this.gridOptions).length === 0 ||
      this.gridOptions === null ||
      this.gridOptions === undefined
    ) {
      this.gridOptions = {
        options: {
          collapseAwareGroupTotals: true,
          groupLevelFontSizes: [13, 13, 13, 13],
        },
      };
    }

    if (this.persistenceKey) {
      const removeState = CommonStorage.getItems("remove_state");

      if (this.persistenceKey) {
        // await DataGridState.checkInDatabase(this.persistenceKey);
        await DataGridState.initializeGridViewDefinition(this.persistenceKey, [
          ...this.columns,
        ]);
      } else if (removeState === "true") {
        await DataGridState.removeState(this.persistenceKey);
      }
      CommonStorage.saveItems("remove_state", false);
    }
  },
  methods: {},
  watch: {
    getTriggerViewDefinitionChange: {
      handler(value) {
        this.$store.dispatch(
          "gridViewDefinition/setTriggerViewDefinitionChange",
          false,
        );
        if (value && this.persistenceKey) {
          const selectedDefinition = this.getSelectedDefinitionByKey(
            this.persistenceKey,
          );
          if (selectedDefinition) {
            if (selectedDefinition.GridDefinition) {
              const GridDefinition = JSON.parse(
                selectedDefinition.GridDefinition,
              );
              if (GridDefinition) {
                CommonStorage.saveItems(
                  this.persistenceKey,
                  JSON.stringify(GridDefinition),
                );
              }
            }

            if (selectedDefinition.FilterDefinition) {
              const FilterDefinition = JSON.parse(
                selectedDefinition.FilterDefinition,
              );

              if (FilterDefinition) {
                const syncedFilterDefinition = syncDateFilters(
                  FilterDefinition,
                  this.deepCloneColumns,
                );

                CommonStorage.saveItems(
                  "filter-panel-" + this.persistenceKey,
                  JSON.stringify(syncedFilterDefinition),
                );
              }
            } else {
              CommonStorage.clear("filter-panel-" + this.persistenceKey);
            }

            this.$nextTick(() => {
              if (this.$refs["dataGridReport"]) {
                this.gridKey = new Date().getTime();
              }
            });
          }
        }
      },
      deep: true,
    },
  },
};
</script>

<style lang="scss" scoped></style>
